import { render, staticRenderFns } from "./package-latest-progress-report-widget.vue?vue&type=template&id=a0e783b8&"
import script from "./package-latest-progress-report-widget.vue?vue&type=script&lang=js&"
export * from "./package-latest-progress-report-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports